// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3v9AO","range":"MonthRangeSwitch_range__Qi1I0","disabled":"MonthRangeSwitch_disabled__2dOMD"};